import { BlameLogType } from '@debbie/common/dist/blamelog/index.js';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import ButtonDrop from '../../ButtonDrop.js';
import { Table } from '../../index.js';
import { Meta } from './style.js';
export const ImportDetails = ({ blamelog }) => {
    const [open, setOpen] = useState(false);
    return (React.createElement(ButtonDrop, { open: open, onOpen: () => setOpen(true), onClose: () => setOpen(false), size: "mini", info: true, maxWidth: "500px", minWidth: "500px" },
        React.createElement(Meta, null,
            React.createElement(Table, { zebra: true },
                React.createElement(ImportDetailsContent, { blamelog: blamelog })))));
};
const ImportDetailsContent = ({ blamelog }) => {
    switch (blamelog.type) {
        case BlameLogType.ImportCreated:
            return React.createElement(ImportCreatedContent, { blamelog: blamelog });
        case BlameLogType.ImportRun:
            return React.createElement(ImportRunContent, { blamelog: blamelog });
        default:
            return null;
    }
};
const ImportCreatedContent = ({ blamelog, }) => {
    const lang = useSelector((s) => s.lang);
    const { details } = blamelog;
    return (React.createElement(React.Fragment, null, details.source && (React.createElement("tr", null,
        React.createElement("td", null,
            React.createElement("b", null, lang.blameLogs.source)),
        React.createElement("td", null, details.source)))));
};
const ImportRunContent = ({ blamelog, }) => {
    const lang = useSelector((s) => s.lang);
    const { details } = blamelog;
    return (React.createElement(React.Fragment, null,
        React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.successCount)),
            React.createElement("td", null, details.successCount)),
        React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.updatedCount)),
            React.createElement("td", null, details.updatedCount)),
        React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.failedCount)),
            React.createElement("td", null, details.failedCount))));
};
//# sourceMappingURL=ImportDetails.js.map